'use client';
import React, { useState } from 'react';

export default function DownloadSection() {
  const [phone, setPhone] = useState('');
  const [sent, setSent] = useState(false);

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (phone.length >= 10) {
      setSent(true);
      setTimeout(() => setSent(false), 4000);
      setPhone('');
    }
  };

  return (
    <section id="download" className="py-24 sm:py-32 relative overflow-hidden">
      <div className="section-divider mb-24" />

      {/* Atmospheric background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="blob-sky absolute top-[-20%] left-[20%] w-[600px] h-[600px] rounded-full opacity-20" />
        <div className="blob-periwinkle absolute bottom-[-20%] right-[10%] w-[500px] h-[500px] rounded-full opacity-20" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 glass-card px-4 py-2 rounded-full mb-8">
          <span className="w-2 h-2 rounded-full bg-sky-DEFAULT animate-pulse" />
          <span className="text-xs font-bold text-chrome uppercase tracking-widest">First Lesson Free — No Card Required</span>
        </div>

        <h2 className="font-sans text-4xl sm:text-5xl lg:text-6xl font-extrabold text-frost tracking-tight leading-tight mb-6">
          Download & start<br />
          <span className="gradient-text-warm font-display italic font-light">your first lesson free.</span>
        </h2>

        <p className="text-chrome text-lg font-light leading-relaxed mb-12 max-w-2xl mx-auto">
          Pick up your kit. Every technique, every angle, ready when your next client sits down.
          847 techniques. Zero guesswork.
        </p>

        {/* App store buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          {/* App Store */}
          <a
            href="#"
            className="btn-primary flex items-center gap-3 px-7 py-4 rounded-2xl text-slate-deep"
            aria-label="Download on the App Store"
          >
            <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <div className="text-left">
              <div className="text-[10px] font-semibold opacity-80 tracking-wide uppercase">Download on the</div>
              <div className="text-base font-bold leading-tight">App Store</div>
            </div>
          </a>

          {/* Google Play */}
          <a
            href="#"
            className="glass-card glow-hover flex items-center gap-3 px-7 py-4 rounded-2xl text-frost transition-all duration-300"
            aria-label="Get it on Google Play"
          >
            <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
              <path d="M3.18 23.76c.37.2.8.22 1.2.06l12.6-7.27-2.74-2.74-11.06 9.95zM20.66 9.65L17.5 7.8 14.4 10.9l3.1 3.1 3.16-1.83c.9-.52.9-1.99 0-2.52zM2.04.28C1.74.53 1.5.92 1.5 1.42v21.16c0 .5.24.89.54 1.14L13.47 12 2.04.28zM4.38.18L16.98 7.45l-2.74 2.74L4.38.18z"/>
            </svg>
            <div className="text-left">
              <div className="text-[10px] font-semibold text-chrome-dim tracking-wide uppercase">Get it on</div>
              <div className="text-base font-bold leading-tight">Google Play</div>
            </div>
          </a>
        </div>

        {/* Desktop — send link */}
        <div className="max-w-md mx-auto">
          <p className="text-chrome-dim text-sm mb-4">On desktop? Send the link to your phone.</p>
          <form onSubmit={handleSend} className="flex gap-2">
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+1 (555) 000-0000"
              className="flex-1 glass-card rounded-full px-5 py-3 text-frost text-sm placeholder:text-chrome-dim focus:outline-none focus:border-sky-DEFAULT/50 transition-colors"
              style={{ background: 'rgba(247,250,252,0.04)' }}
            />
            <button
              type="submit"
              className="btn-primary px-6 py-3 rounded-full text-slate-deep font-bold text-sm shrink-0"
            >
              {sent ? '✓ Sent!' : 'Send Link'}
            </button>
          </form>
          {sent && (
            <p className="text-sky-DEFAULT text-xs mt-3 font-medium">
              ✓ Download link sent to your phone!
            </p>
          )}
          <p className="text-chrome-dim text-[11px] mt-3 font-light">
            We'll send a one-time SMS. No marketing. No spam.
          </p>
        </div>
      </div>
    </section>
  );
}